import { AvatarIcon } from '../../assets/AvatarIcon';
import classNames from 'classnames';
import React from 'react';
const Avatar = ({
  src,
  avatarClassName,
  iconClassName = ''
}) => {
  const avatar = classNames(`${avatarClassName ?? ''}`, 'rounded-full');
  const avatarWithImg = classNames(avatar, 'inline-block');
  const avatarWithoutImg = classNames(avatar, 'bg-slate-400', 'flex', 'items-center', 'justify-center', 'overflow-hidden');
  return src ? /*#__PURE__*/React.createElement("img", {
    "data-testid": "avatar",
    className: avatarWithImg,
    src: src,
    alt: "avatar",
    id: "avatar"
  }) : /*#__PURE__*/React.createElement("div", {
    "data-testid": "avatar",
    className: avatarWithoutImg,
    id: "avatar"
  }, AvatarIcon(iconClassName));
};
export default Avatar;